import React, { useEffect, useReducer, useState } from 'react';

import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row, Space, Spin, Table, Typography } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, WifiOutlined, InfoOutlined, EyeOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import axios from 'axios';
import wellFieldsReducer from './reducer';
import { WELL_FIELDS_LIST, WELL_FIELDS_LIST_ERROR, WELL_FIELDS_LIST_SUCCESS, WELL_FIELDS_UPDATE_DATA } from './constants';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function WellFields() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const initalState = {wellFields : [], loading: false, error: false, updateData : {}};
	const [data, dispatch] = useReducer(wellFieldsReducer, initalState);
	const [showAddModal, setShowAddModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [updateId, setUpdateId] = useState();
	const [deleteId, setDeleteId] = useState();
	const navigate = useNavigate();
		
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		loadWellFields();
	},[]);

	const loadWellFields = () => {
		dispatch({ type : WELL_FIELDS_LIST });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/wellfields?$sort[id]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`	
			}
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200){
					dispatch({ type : WELL_FIELDS_LIST_SUCCESS, payload : response.data.data });
				} else {
					dispatch({ type : WELL_FIELDS_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : WELL_FIELDS_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const column = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: langdata && langdata.EastingStartDistancem ? langdata.EastingStartDistancem : 'Easting Start Distance (m)',
			dataIndex: 'distanceFrom',
			key: 'distanceFrom',
		},
		{
			title: langdata && langdata.EastingEndDistancem ? langdata.EastingEndDistancem : 'Easting End Distance (m)',
			dataIndex: 'distanceTo',
			key: 'distanceTo',
		},
		{
			title: langdata && langdata.NorthingStartDistancem ? langdata.NorthingStartDistancem : 'Northing Start Distance (m)',
			dataIndex: 'distanceYFrom',
			key: 'distanceYFrom',
		},
		{
			title: langdata && langdata.NorthingEndDistancem ? langdata.NorthingEndDistancem : 'Northing End Distance (m)',
			dataIndex: 'distanceYTo',
			key: 'distanceYTo',
		},
		{
			title: langdata && langdata.StartDepth ? langdata.StartDepth : 'Start Depth (m)',
			dataIndex: 'depthFrom',
			key: 'depthFrom',
		},
		{
			title: langdata && langdata.EndDepth ? langdata.EndDepth : 'End Depth (m)',
			dataIndex: 'depthTo',
			key: 'depthTo',
		},
		{
			title: `${langdata && langdata.Directory ? langdata.Directory:'Directory'}`,
			dataIndex: 'directory',
			key: 'directory',
		},
		{
			title: `${langdata && langdata.FileName ? langdata.FileName:'FileName'}`,
			dataIndex: 'fileName',
			key: 'fileName',
		},
	];

	permission==='superadmin' || permission === 'admin' ? 
		column.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.View ? langdata.View : 'View'} onClick={() => {handleView(record);}} ><EyeOutlined/></a>
					<a title={langdata && langdata.Editwellfield ? langdata.Editwellfield : 'Edit well field'} onClick={() => {handleEditModal(record);}} ><EditOutlined/></a>
					{permission==='superadmin' ?
						<a title={langdata && langdata.Deletewellfield ? langdata.Deletewellfield : 'Delete well field'} onClick={() => {handleDeleteModal(record);}} ><DeleteOutlined /></a>
						: null }
				</Space>
			)
		}) : null;

	const handleAddModal = () => {
		setShowAddModal(true);
	};

	const handleView =(record)=>{		

		const fieldminDistance = record.distanceFrom;
		const fieldmaxDistance = record.distanceTo;

		const fieldyminDistance = record.distanceYFrom;
		const fieldymaxDistance = record.distanceYTo;

		navigate(( '/wellfield-view'),{ state: { data: {FieldName:record.name, fieldminDistance:fieldminDistance, fieldmaxDistance:fieldmaxDistance,
			fieldyminDistance :fieldyminDistance, fieldymaxDistance:fieldymaxDistance, wellFieldId : record.id}, path: 'well-field' } });
	};

	const closeModal = () => {
		setShowAddModal(false);
		setShowEditModal(false);
		setShowDeleteModal(false);
	};

	const handleEditModal = (value) => {
		setShowEditModal(true);
		setUpdateId(value.id);
		dispatch({ type : WELL_FIELDS_UPDATE_DATA, payload : value});
	};

	const handleDeleteModal = (value) => {
		setShowDeleteModal(true);
		setDeleteId(value.id);
	};

	const addFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: null,
			distanceFrom: null,
			distanceTo: null,
			depthFrom: null,
			depthTo: null,
			directory : '',
			fileName : '',
			distanceYFrom: null,
			distanceYTo: null,
		},
		onSubmit: (values) => {
			const {name, distanceFrom, distanceTo, depthFrom, depthTo, directory, fileName, distanceYFrom, distanceYTo} = values;
			if( name == null || name == '' || isNaN(distanceFrom), isNaN(distanceTo), isNaN(depthFrom), isNaN(depthTo), isNaN(distanceYFrom), isNaN(distanceYTo)){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			let data = JSON.stringify({
				'name': name,
				'distanceFrom': parseInt(distanceFrom),
				'distanceTo': parseInt(distanceTo),
				'depthFrom': parseInt(depthFrom),
				'depthTo': parseInt(depthTo),
				'directory' : directory,
				'fileName' : fileName,
				'pipelineId': parseInt(pipelineId),
				'distanceYFrom': parseInt(distanceYFrom),
				'distanceYTo': parseInt(distanceYTo)
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/wellfields`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						Modal.success({ title: langdata && langdata.Wellfieldaddedsuccessfully ? langdata.Wellfieldaddedsuccessfully : 'Well field added successfully.' });	
						loadWellFields();
						addFormik.resetForm();
					} else {
						Modal.warning({ title: langdata && langdata.Wellfieldnotadded ? langdata.Wellfieldnotadded : 'Well field not added.' });					
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Wellfieldnotadded ? langdata.Wellfieldnotadded : 'Well field not added.' });					
					}
				});
			setShowAddModal(false);				
		}
	});

	const editFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data.updateData.name,
			distanceFrom: data.updateData.distanceFrom,
			distanceTo: data.updateData.distanceTo,
			depthFrom: data.updateData.depthFrom,
			depthTo: data.updateData.depthTo,
			directory : data.updateData.directory,
			fileName : data.updateData.fileName,
			distanceYFrom: data.updateData.distanceYFrom,
			distanceYTo: data.updateData.distanceYTo,

		},
		onSubmit: (values) => {
			const {name, distanceFrom, distanceTo, depthFrom, depthTo, directory, fileName, distanceYFrom, distanceYTo} = values;
			if( name == null || name == ''  || isNaN(distanceFrom), isNaN(distanceTo), isNaN(depthFrom), isNaN(depthTo), isNaN(distanceYFrom), isNaN(distanceYTo)){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			let data = JSON.stringify({
				'name': name,
				'distanceFrom': parseInt(distanceFrom),
				'distanceTo': parseInt(distanceTo),
				'depthFrom': parseInt(depthFrom),
				'depthTo': parseInt(depthTo),
				'directory':directory,
				'fileName': fileName,
				'distanceYFrom': parseInt(distanceYFrom),
				'distanceYTo': parseInt(distanceYTo)
			});

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/wellfields/${updateId}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						Modal.success({ title: langdata && langdata.Wellfieldupdatedsuccessfully ? langdata.Wellfieldupdatedsuccessfully : 'Well field updated successfully.' });					
						loadWellFields();
					} else {
						Modal.warning({ title: langdata && langdata.Wellfieldnotupdated ? langdata.Wellfieldnotupdated : 'Well field not updated.' });					
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Wellfieldnotupdated ? langdata.Wellfieldnotupdated : 'Well field not updated.' });					
					}
				});
			setShowEditModal(false);
		}
	});

	const handleDelete = () => {

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/wellfields/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				},
			data : data
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadWellFields();
					Modal.success({ title: langdata && langdata.Wellfielddeletedsuccessfully ? langdata.Wellfielddeletedsuccessfully : 'Well field deleted successfully.' });					
				} else {
					Modal.warning({ title: langdata && langdata.Wellfieldnotdeleted ? langdata.Wellfieldnotdeleted : 'Well field not deleted.' });					
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Wellfieldnotdeleted ? langdata.Wellfieldnotdeleted : 'Well field not deleted.' });
				}
			});
		setShowDeleteModal(false);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.WellFieldsDescription1 ? langdata.WellFieldsDescription1 : 'The Well Fields section is used to manage the grouping of wells into specific fields. It helps organize and categorize wells based on their geographic or operational location, making it easier to manage and analyze data at a group level.'} </p>
		</Card>
	);
	
	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<WifiOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.WellFieldsManagement ? langdata.WellFieldsManagement : 'Well Fields Management'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{permission==='superadmin' || permission === 'admin' ?
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={handleAddModal}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
								
							<Popover title={langdata && langdata.WellFieldsManagement ? langdata.WellFieldsManagement : 'Well Fields Management'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>

			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data && data.wellFields.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { column } 
							dataSource = { data.wellFields } 
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>
			
			<Modal
				title={langdata && langdata.AddWellFields ? langdata.AddWellFields : 'Add Well Fields'}
				centered
				open={showAddModal}
				onOk={{closeModal}}
				onCancel={closeModal}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary" onClick={addFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={700}
			>
				<Form layout="vertical" onSubmit={addFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthefieldname ? langdata.Pleaseenterthefieldname : 'Please enter the field name' }]} required>
								<Input 
									name="name" 
									onChange={addFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthefieldname ? langdata.Pleaseenterthefieldname : 'Please enter the field name'} 
									value={addFormik.values.name} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.EastingStartDistancem ? langdata.EastingStartDistancem : 'Easting Start Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance' }]} required>
								<Input 
									name="distanceFrom" 
									onChange={addFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance'} 
								/>
							</Form.Item>
						</Col>
					</Row>


					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.EastingEndDistancem ? langdata.EastingEndDistancem : 'Easting End Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance' }]} required>
								<Input 
									name="distanceTo" 
									onChange={addFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance'} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.NorthingStartDistancem ? langdata.NorthingStartDistancem : 'Northing Start Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance' }]} required>
								<Input 
									name="distanceYFrom" 
									onChange={addFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance'} 
								/>
							</Form.Item>
						</Col>
					</Row>


					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.NorthingEndDistancem ? langdata.NorthingEndDistancem : 'Northing End Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance' }]} required>
								<Input 
									name="distanceYTo" 
									onChange={addFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance'} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.StartDepth ? langdata.StartDepth : 'Start Depth (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthestartdepth ? langdata.Pleaseenterthestartdepth : 'Please enter the start depth (m)' }]} required>
								<Input 
									name="depthFrom" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthestartdepth ? langdata.Pleaseenterthestartdepth : 'Please enter the start depth (m)'}
									onChange={addFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.EndDepth ? langdata.EndDepth : 'End Depth (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheenddepth ? langdata.Pleaseentertheenddepth : 'Please enter the end depth (m)' }]} required>
								<Input 
									name="depthTo" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseentertheenddepth ? langdata.Pleaseentertheenddepth : 'Please enter the end depth (m)'}
									onChange={addFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.Directory ? langdata.Directory : 'Directory'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]}>
								<Input 
									name="directory" 
									placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.directory}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]}>
								<Input 
									name="fileName" 
									placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
									onChange={addFormik.handleChange} 
									value={addFormik.values.fileName}
								/>
							</Form.Item>
						</Col>
					</Row>

				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.EditWellFields ? langdata.EditWellFields : 'Edit Well Fields'}
				centered
				open={showEditModal}
				onOk={{closeModal}}
				onCancel={closeModal}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary" onClick={editFormik.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={700}
			>
				<Form layout="vertical" onSubmit={editFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'}
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthefieldname ? langdata.Pleaseenterthefieldname : 'Please enter the field name' }]} required>
								<Input 
									name="name" 
									onChange={editFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthefieldname ? langdata.Pleaseenterthefieldname : 'Please enter the field name'} 
									value={editFormik.values.name} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.EastingStartDistancem ? langdata.EastingStartDistancem : 'Easting Start Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance' }]} required>
								<Input 
									name="distanceFrom" 
									onChange={editFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance'} 
									value={editFormik.values.distanceFrom} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.EastingEndDistancem ? langdata.EastingEndDistancem : 'Easting End Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance' }]} required>
								<Input 
									name="distanceTo" 
									onChange={editFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance'} 
									value={editFormik.values.distanceTo} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.NorthingStartDistancem ? langdata.NorthingStartDistancem : 'Northing Start Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance' }]} required>
								<Input 
									name="distanceYFrom" 
									onChange={editFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthestartdistance ? langdata.Pleaseenterthestartdistance : 'Please enter the start distance'}
									value={editFormik.values.distanceYFrom}
								/>
							</Form.Item>
						</Col>
					</Row>


					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.NorthingEndDistancem ? langdata.NorthingEndDistancem : 'Northing End Distance (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance' }]} required>
								<Input 
									name="distanceYTo" 
									onChange={editFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseentertheenddistance ? langdata.Pleaseentertheenddistance : 'Please enter the end distance'}
									value={editFormik.values.distanceYTo}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.StartDepth ? langdata.StartDepth : 'Start Depth (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthestartdepth ? langdata.Pleaseenterthestartdepth : 'Please enter the start depth (m)' }]} required>
								<Input 
									name="depthFrom" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseenterthestartdepth ? langdata.Pleaseenterthestartdepth : 'Please enter the start depth (m)'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.depthFrom} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.EndDepth ? langdata.EndDepth : 'End Depth (m)'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseentertheenddepth ? langdata.Pleaseentertheenddepth : 'Please enter the end depth (m)' }]} required>
								<Input 
									name="depthTo" 
									type='number'
									onWheel={(e) => e.target.blur()}
									placeholder={langdata && langdata.Pleaseentertheenddepth ? langdata.Pleaseentertheenddepth : 'Please enter the end depth (m)'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.depthTo} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.Directory ? langdata.Directory : 'Directory'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory' }]}>
								<Input 
									name="directory" 
									placeholder={langdata && langdata.Pleaseenterthedirectory ? langdata.Pleaseenterthedirectory : 'Please enter the directory'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.directory}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.FileName ? langdata.FileName : 'File Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter file name' }]}>
								<Input 
									name="fileName" 
									placeholder={langdata && langdata.Pleaseenterfilename ? langdata.Pleaseenterfilename : 'Please enter the file name'}
									onChange={editFormik.handleChange} 
									value={editFormik.values.fileName}
								/>
							</Form.Item>
						</Col>
					</Row>



				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={closeModal} onCancel={closeModal}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis :'Are you sure you want to delete this ?'}</Col>
				</Row>
			</Modal>


			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}